import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X, Download, Smartphone } from 'lucide-react';

export const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Check if already installed
    const standalone = window.matchMedia('(display-mode: standalone)').matches || 
                      window.navigator.standalone === true;
    setIsStandalone(standalone);

    // Check if iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(iOS);

    // Listen for install prompt
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Show prompt after 3 seconds if not dismissed before
      const dismissed = localStorage.getItem('pwa-prompt-dismissed');
      if (!dismissed) {
        setTimeout(() => setShowPrompt(true), 3000);
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    // Show iOS prompt if on iOS and not installed
    if (iOS && !standalone) {
      const dismissed = localStorage.getItem('pwa-prompt-dismissed');
      if (!dismissed) {
        setTimeout(() => setShowPrompt(true), 3000);
      }
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-prompt-dismissed', 'true');
  };

  // Don't show if already installed
  if (isStandalone || !showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 animate-fade-in md:left-auto md:right-4 md:w-96">
      <div className="bg-slate-900 border border-sky-500/30 rounded-lg shadow-xl p-4">
        <button 
          onClick={handleDismiss}
          className="absolute top-2 right-2 text-slate-500 hover:text-white"
        >
          <X className="w-4 h-4" />
        </button>
        
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 rounded-lg bg-sky-500/20 flex items-center justify-center flex-shrink-0">
            <Smartphone className="w-6 h-6 text-sky-400" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-white mb-1">Instalar Navalec</h3>
            {isIOS ? (
              <p className="text-sm text-slate-400 mb-3">
                Toca <span className="text-sky-400">Compartir</span> y luego <span className="text-sky-400">"Añadir a pantalla de inicio"</span>
              </p>
            ) : (
              <>
                <p className="text-sm text-slate-400 mb-3">
                  Instala la app para un acceso más rápido
                </p>
                <Button 
                  onClick={handleInstall}
                  size="sm"
                  className="bg-sky-600 hover:bg-sky-500 text-white gap-2"
                >
                  <Download className="w-4 h-4" />
                  Instalar App
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
